import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StoryblokImage } from '~app/modules/storyblok/models';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { ContentCardClickApplicationEvent } from '~shared/modules/application-event/models';
import { environment } from '~env/environment';

@Component({
  selector: 'app-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCardComponent {
  @Input() image: StoryblokImage;
  @Input() title: string;
  @Input() subtext: string;
  @Input() linkedText: string;
  @Input() link: string;

  sbFormatParam = '/m/';

  readonly MARKETPLACELINK = environment.appBaseUrl();

  constructor(private applicationEventService: ApplicationEventService) {}

  fireGAEvent(): void {
    this.applicationEventService.publish(new ContentCardClickApplicationEvent({ label: this.link }));
  }

  goTo(): void {
    window.location.href = this.MARKETPLACELINK + this.link;
  }
}
